export enum MatchStatisticType {
  TOTAL_SHOTS = 1,
  SHOTS_ON_TARGET = 2,
  CORNERS = 6,
  OFFSIDES = 7,
  FREE_KICKS = 10,
  POST_HITS = 16,
  CHANCES = 17,
  SAVES = 21,
  YELLOW_CARDS = 22,
  RED_CARDS = 23,
}
